import React from 'react'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'

import type { CurrencyModel } from '@root/entities/currency'
import type { PairAddress } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type TransactionListItemAmountProps = {
  currency?: CurrencyModel
  primary: React.ReactNode
  secondary: React.ReactNode
  pairAddress?: PairAddress
  iconSize: number
  auxIconSize?: number
} & ClassNameProps

const AUX_RATIO = 0.385

export const TransactionListItemAmount: React.FC<
  TransactionListItemAmountProps
> = ({
  currency,
  primary,
  secondary,
  className,
  pairAddress,
  iconSize,
  auxIconSize = Math.round(AUX_RATIO * iconSize),
}) => {
  return (
    <Root className={className}>
      {currency ? (
        <CurrencyIcon
          currency={currency}
          size={iconSize}
          auxIconSize={auxIconSize}
          withNetwork
          pairAddress={pairAddress}
        />
      ) : undefined}
      <Group>
        <Primary ellipsis>{primary}</Primary>
        <Secondary ellipsis>{secondary}</Secondary>
      </Group>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 5px;
  grid-auto-flow: column;
  align-items: start;
  justify-content: start;

  align-items: start;

  > div:first-child {
    padding-top: 1px;
  }
`

const Group = styled.div`
  display: grid;
`

const Primary = styled(Typography).attrs({
  variant: 'body5-semi-bold',
})`
  color: var(--appearance-12);
  white-space: nowrap;
`

const Secondary = styled(Typography).attrs({
  variant: 'description-semi-bold',
})`
  color: var(--text-8);
`
